<template>
	<div>
		<triangle-image
			title="Come riciclare la tua Box"
		/>

		<div class="container">
			<div class="content">

				<section class="">
					<p><span v-html="$root.source === 'bennet' ? 'Una ' : 'Qui in Quomi, una '"/>delle nostre priorità, è garantire che i tuoi ingredienti arrivino freschi e sicuri nella <b>confezione più rispettosa dell'ambiente</b> possibile. La maggior parte degli imballaggi che utilizziamo nelle nostre Box è completamente riciclabile o biodegradabile. Stiamo lavorando duramente per <b>ridurre la quantità di imballaggi</b> che utilizziamo, trovare imballaggi più facili da riciclare localmente e <b>individuare opzioni sempre più ecosostenibili.</b></p>

					<p>
						&#127795; In più per ogni ordine effettuato sul nostro sito <b>pianteremo un albero</b> in partnership con l’associazione <b>“Eden Reforestation Projects”</b>. In questo modo miriamo a combattere in maniera concreta la deforestazione, una delle cause principali dei cambiamenti climatici.
						<router-link :to="{ name: 'edenTree'}" class="link-detail">Scopri di più qui</router-link>.
					</p>
				</section>

				<h2 class='center'>Qui sotto puoi trovare tutte le indicazioni su come riciclare al meglio la tua Box <span v-html="$root.source === 'bennet' ? 'Instacook ' : 'Quomi'"/></h2>

				<section>
					<div class="image">
						<img :src="$root.source === 'bennet' ? 'https://api.quomi.it/oldimg/scatola-.webp' : 'https://api.quomi.it/oldimg/box-%282%29.webp'	 ">
					</div>

					<div class="description">
						<h2>Box esterna</h2>
						<p><b>Di cosa è fatta?</b> Di un misto di carta riciclata e vergine.</p>
						<p><b>Dove si ricicla?</b> Nel contenitore della carta. Puoi aprirla e appiattirla o utilizzarla a sua volta come contenitore della carta. Oppure puoi darle una nuova vita con la tua creatività :)</p>
					</div>
				</section>

				<hr>

				<section>
					<div class="description">
						<h2>Imballaggio freschi</h2>
						<p><b>Di cosa è fatto?</b> L'innovativo imballaggio WrapPack, pluripremiato per la sua sostenibilità ambientale, è realizzato al 100% in carta.</p>
						<p><b>Dove si ricicla?</b> Nel contenitore della carta.</p>
					</div>

					<div class="image">
						<img :src="$root.source === 'bennet'  ? 'https://api.quomi.it/oldimg/box-instacook.webp' : 'https://api.quomi.it/oldimg/imballaggio-fresco-Quomi.webp'">
					</div>
				</section>

				<hr>

				<section>
					<div class="image">
						<img :src="$root.source === 'bennet' ? 'https://api.quomi.it/oldimg/ghiaccio-instacook.webp' : 'https://api.quomi.it/oldimg/nuova-busta-ghiaccio-ok.jpg'">
					</div>

					<div class="description">
						<h2>Buste Ghiaccio</h2>
						<p><b>Di cosa sono fatte?</b> L’involucro esterno è un laminato a base di carta, mentre l'interno è riempito con una soluzione all'acqua 100% biodegradabile e non tossica.</p>
						<p><b>Dove si ricicla?</b> Taglia un angolo e svuota il contenuto sicuro per l'ambiente nel lavandino o nell'umido. L'involucro esterno va riposto nel contenitore dell’indifferenziata. Oppure riutilizza la busta ghiaccio quante volte vuoi!.</p>
					</div>
				</section>

				<hr>

				<section>
					<div class="description">
						<h2>Flyer, Fascette e Buste di Carta</h2>
						<p><b>Di cosa sono fatte?</b> Di un misto di carta riciclata e vergine, alcune interamente di carta riciclata. </p>
						<p><b>Dove si riciclano?</b> Nel contenitore della carta.</p>
					</div>

					<div class="image">
						<img :src="$root.source === 'bennet' ? 'https://api.quomi.it/oldimg/flyer-instacook.webp' : 'https://api.quomi.it/oldimg/flyer-quomi.webp'">
					</div>
				</section>

				<hr>

				<section class="top">
					<div class="description">
						<h2>Sacchetti Frutta e Verdura</h2>
						<p><b>Di cosa sono fatti?</b> Sono interamente biodegradabili e compostabili.</p>
						<p><b>Dove si riciclano?</b> Nel contenitore dell’umido. Ricordati di rimuovere eventuali etichette o laccetti di chiusura.</p>
					</div>

					<div class="description">
						<h2>Pack dei prodotti</h2>
						<p><b>Di cosa sono fatti?</b> Hanno varie composizioni e puoi trovare su ognuno l’indicazione specifica della natura del pack (es. plastica, alluminio, vetro).</p>
						<p><b>Dove si riciclano?</b> Trovi sul pack l’indicazione specifica sul contenitore adatto. <span class="tag-partner">Ad esempio, le vaschette di Lombardia Carni sono completamente riciclabili nella Plastica.</span></p>
					</div>
				</section>

				<hr>

				<div>
					<br>
					<p>Per maggiori informazioni, <b>consulta sempre le indicazioni fornite dal tuo comune di appartenenza</b> per un corretto smaltimento di tutti i materiali.</p>

					<p>Ogni tuo feedback o consiglio è sempre il benvenuto. Costruiamo insieme una filiera del cibo più sostenibile. Contattaci per ogni suggerimento o informazione.</p>

					<p class="tag-partner">Scopri anche come selezioniamo i nostri produttori e gli ingredienti per costruire una <b>filiera del cibo più sostenibile.</b></p> 
					
					<router-link
						:to="{ name: 'suppliers' }"
						class="flex-center tag-partner"
					>
						<CTA
							:content="`Scopri i produttori`"
							isArrow
						/>
					</router-link>
					
					<br>
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import TriangleImage from '../TriangleImage'

export default {
	components: {
		TriangleImage
	}
}

</script>

<style scoped>
	.content {
		max-width: 1024px;
	}

	.content > section {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between;
		
		margin: 0px auto 30px auto;
	}

	.content > section.top {
		align-items: flex-start;
	}

	h2 {
		margin-bottom: 30px;
	}

	h3 {
		text-align: center;
	}

	.content > section > div {
		padding: 20px 0px;
		max-width: 470px;
		margin: 0 auto;
	}

	.content > section .image {
		text-align: center;
	}

	.link {
		color: #399ec9;
	}

	.link:hover {
		color: #328fb7;
		text-decoration: underline;
	}

	.icon-contact {
		width: 35px;
		margin-right: 10px;
	}

	.contacts,
	.abo {
		display: flex;
		flex-direction: column;
		align-self: start;
	}

	.calendar {
		margin: 10px 0;
	}

	.contacts-list {
		list-style: none;
	}

	.contacts-list {
		text-align: left;
		width: 250px;
	}

	.contacts-list li {
		padding: 10px 0;
	}

	.triangle-image {
		background-image: url("https://api.quomi.it/oldimg/sostenibilit%C3%A0-quomi.webp");
		background-position: center 85%;
	}

	.fa-question-circle {
		color: var(--quomi-primary);
	}

</style>
